import APIService from '@/services/APIService.js';

export default {
  getComparativos(includeExpiredRecords) {
    return APIService.apiCall().get(`/comparativoBdgdAis/getComparativos/${includeExpiredRecords}`);
  },
  deleteComparativo(id) {
    return APIService.apiCall().get(`/comparativoBdgdAis/delete/${id}`);
  },
  executarComparativo(id) {
    return APIService.apiCall().get(`/comparativoBdgdAis/executar/${id}`);
  },
  duplicarComparativo(id) {
    return APIService.apiCall().get(`/comparativoBdgdAis/duplicar/${id}`);
  },
  getComparativo(id) {
    return APIService.apiCall().get(`/comparativoBdgdAis/getComparativo/${id}`);
  },
  salvarComparativo(postData, id) {
    return APIService.apiCall().post(`/comparativoBdgdAis/salvar/${id}`, JSON.stringify(postData));
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/comparativoBdgdAis/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  },
  andamento(id) {
    return APIService.apiCall().get(`/comparativoBdgdAis/andamento/${id}`);
  }
};
